<template>
  <el-card id="myDatabaseOrderList">
    <template #header>
      <span>公司订单</span>
    </template>
    <el-row>
      <el-col>
        <PersonCenterTable v-bind="byCondition" @get-data="getConditionOrder">
          <template #tableColumn>
            <!-- eslint-disable -->
            <el-table-column v-for="(column,index) in byCondition.table.columns" :key="index" :show-overflow-tooltip="true"
                             :prop="column.prop" :label="column.label" :width="column.width">
              <template v-slot="scope">
                <span v-html="scope.row[column.prop]"></span>
              </template>
            </el-table-column>
          </template>
        </PersonCenterTable>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import PersonCenterTable from "@/pages/userCenter/ChildComps/PersonCenterTable";
import CompanyOrderListMixin from "@/pages/userCenter/Mixins/CompanyOrderListMixin";
export default {
  //此处定义传入的数据
  props: {
    companyId: Number,
  },
  components: {
    PersonCenterTable
  },
  mixins: [CompanyOrderListMixin]
}
</script>

<style scoped>

</style>
